import { createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../api/apiSlice";

const adminAdaptor = createEntityAdapter({
    selectId: (entity) => entity.community_admin_id,
})

const initialAdmin = adminAdaptor.getInitialState()

export const extendedApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getcomplainAdmin: builder.query({
            query: () => '/b2g/eco-admin/complain/offline',
            transformResponse: responseData => {
                if (responseData?.status === false) {
                    throw new Error(responseData?.statusCode)
                }
                return adminAdaptor.setAll(initialAdmin, responseData?.data)
            },
            providesTags: (result, error, arg) => {
                console.log("result",result?.entities?.undefined);
                
                if (error || !result?.entities?.undefined?.ids) {
                    return [{ type: 'B2gAdmin', id: 'List' }, []];
                } else {
                    return result?.entities?.undefined?.map(id => ({ type: 'B2gAdmin', id }));
                }
            }
        }),
        getcompalinAdminStatus: builder.query({
            query: () => '/b2g/eco-admin/complain/offline/status',
            transformResponse: responseData => {
                if (responseData?.status === false) {
                    throw new Error(responseData?.statusCode)
                }
                return responseData?.data
            },
            // providesTags: (result, error, arg) => {
            //     if (error || !result?.ids) {
            //         return [{ type: 'B2gCompalinWeb', id: 'List' }, []];
            //     } else {
            //         return result.ids.map(id => ({ type: 'B2gCompalinWeb', id }));
            //     }
            // }
        }),
        editcomplainApp: builder.mutation({
            query:payLoad => ({
                url: `/b2g/eco-admin/complain/offline/${payLoad.id}`,
                method: 'PATCH',
                body: payLoad
            }),
            // invalidatesTags: [
            //     { type: 'B2gUserApp', id: 'List' }
            // ]
        }),
        addcomplainAdmin: builder.mutation({
            query: body => ({
                url: '/b2g/eco-admin/complain/offline',
                method: 'POST',
                body: body
            }),
            invalidatesTags: [
                { type: 'B2gAdmin', id: 'List' }
            ]
        })
    })
})

export const {
    useGetcomplainAdminQuery,
    useGetcompalinAdminStatusQuery,
    useEditcomplainAppMutation,
    useAddcomplainAdminMutation
} = extendedApiSlice
